import { SupplierAndStockLocationDTO, SupplierTag } from '@luminovo/http-client';

export function hasSupplierTag(supplier: Pick<SupplierAndStockLocationDTO, 'tags'>, supplierTag: SupplierTag): boolean {
    return supplier.tags.some(({ tag }) => tag === supplierTag);
}
